import { computed } from 'vue'
import useAppStore from '@views/app.store.ts'
import deepSeekIcon from '@/assets/images/ai/deepSeek.png'
import doubaoIcon from '@/assets/images/ai/doubao.png'
import tongYiIcon from '@/assets/images/ai/tongYi.png'
import yuanBaoIcon from '@/assets/images/ai/yuanBao.png'
import wenXinIcon from '@/assets/images/ai/wenXin.png'
import naMiIcon from '@/assets/images/ai/naMi.png'
// import zhipuIcon from '@/assets/images/ai/zhipu.png'
import kimiIcon from '@/assets/images/ai/kimi.png'

import googleIcon from '@/assets/images/ai/google.png'
import chatGptIcon from '@/assets/images/ai/chatGpt.png'
import geminiIcon from '@/assets/images/ai/gemini.png'
import perplexityIcon from '@/assets/images/ai/perplexity.png'
import copilotIcon from '@/assets/images/ai/copilot.png'

// 模型对应列表
export const domesticModels = [
  { label: '豆包', value: 'douBao', icon: doubaoIcon },
  { label: 'DeepSeek', value: 'deepseek', icon: deepSeekIcon },
  { label: '文心一言', value: 'wenXin', icon: wenXinIcon },
  { label: '腾讯元宝', value: 'yuanBao', icon: yuanBaoIcon },
  { label: '通义千问', value: 'tongYi', icon: tongYiIcon },
  { label: '纳米AI', value: 'naMi', icon: naMiIcon },
  // { label: '智谱', value: 'zhipu', icon: zhipuIcon },
  { label: 'Kimi', value: 'kimi', icon: kimiIcon },
]
export const foreignModels = [
  { label: 'Google AIO', value: 'google', icon: googleIcon },
  { label: 'Google AIM', value: 'googleAIM', icon: googleIcon },
  { label: 'Google Gemini', value: 'gemini', icon: geminiIcon },
  { label: 'Perplexity', value: 'perplexity', icon: perplexityIcon },
  { label: 'Bing Copilot', value: 'bingCopilot', icon: copilotIcon },
  { label: 'ChatGPT', value: 'chatGpt', icon: chatGptIcon },
]

export const modelList = computed({
  get() {
    const appStore = useAppStore()
    return appStore.geoMode === 'inner' ? domesticModels : foreignModels
  },
})
// 汇总所有的模型Map数据
// const modelMap = (() => {
//   const map = new Map()
//   modelList.value.forEach(item => {
//     map.set(item.value, item)
//   })
//   return map
// })()
const modelMap = computed(() => {
  const map = new Map()
  modelList.value.forEach(item => {
    map.set(item.value, item)
  })
  return map
})
export function getModelName(value) {
  const model = modelMap.value.get(value)
  return model || { label: value, value, icon: '' }
}

export const messageTypeData = {
  // 报告节点
  // 201: {
  //   messageType: 201,
  //   name: '任务发起',
  // },
  // 202: {
  //   messageType: 202,
  //   name: '任务清单',
  // },
  203: {
    messageType: 203,
    name: '任务1:网站爬取',
  },
  204: {
    messageType: 204,
    name: '任务2:信息提取',
  },
  205: {
    messageType: 205,
    name: '任务3:问题生成',
  },
  206: {
    messageType: 206,
    name: '任务4:信息收集',
  },
  207: {
    messageType: 207,
    name: '任务5:报告输出',
  },
  // GEO任务节点
  // 301: {
  //   messageType: 301,
  //   name: '任务发起',
  // },
  303: {
    messageType: 303,
    name: '关键词资料',
  },
  // 304: {
  //   messageType: 304,
  //   name: '变更关键词资料',
  // },
  305: {
    messageType: 305,
    name: '补充关键词资料',
  },
  315: {
    messageType: 315,
    name: '企业资料',
  },
  316: {
    messageType: 316,
    name: '关键词语料',
  },
  317: {
    messageType: 317,
    name: '关键词文章',
  },
  318: {
    messageType: 318,
    name: '媒体发布',
  },
  320: {
    messageType: 320,
    name: '发布结果',
  },
  321: {
    messageType: 321,
    name: '月报',
  },
  322: {
    messageType: 322,
    name: '关键词收录',
  },
  323: {
    messageType: 323,
    name: '关键词报表',
  },
  // 网站GEO分析
  602: {
    messageType: 602,
    name: '站点基础信息检查',
  },
  603: {
    messageType: 603,
    name: '多维GEO信息检查',
  },
  604: {
    messageType: 604,
    name: '报告计算与生成',
  },
  605: {
    messageType: 605,
    name: '多格式报告导出',
  },
}

export const domesticCategories = [
  { label: '问题/痛点驱动型关键词', list: [] },
  { label: '解决方案/需求探索型关键词', list: [] },
  { label: '产品/服务发现与比较型关键词', list: [] },
  { label: '使用场景/行业应用型关键词', list: [] },
  { label: '学习/操作/资源型关键词', list: [] },
  { label: '品牌/精确查找型关键词', list: [] },
  { label: '地域/本地化服务型关键词', list: [] },
]
export const foreignCategories = [
  { label: 'Problem/Pain Point-Driven Keywords', list: [] },
  { label: 'Solution/Demand Exploration Keywords', list: [] },
  { label: 'Product/Service Discovery & Comparison Keywords', list: [] },
  { label: 'Use Case/Industry Application Keywords', list: [] },
  { label: 'Learning/Operation/Resource Keywords', list: [] },
  { label: 'Brand/Exact Search Keywords', list: [] },
  { label: 'Geographic/Localized Service Keywords', list: [] },
]
